import openFormStatus from '../form/form';

let data;

$('.requestUserCallback').click(function (e) {
  e.preventDefault();

  // показываем форму, перелаем в неё заголовок и сообщение
  openFormStatus('Заявка принята', 'Наш сотрудник позвонит Вам <br>через 3 минуты.');

  $.post(
    "/", //куда отправить

    {
      //что отправить
      data: data,
      data2: data,
      data3: data,
    },

    //делаем что-то при ответе от сервера
    function(response) {
      console.log(response);


    }
  );
})

$('.remindUserCallbackLater').click(function (e) {
  e.preventDefault();

  // показываем форму, перелаем в неё заголовок и сообщение
  openFormStatus('Хорошо!', 'Мы напомним Вам о предложении через полгода.');

  $.post(
    "/", //куда отправить
    {
      //что отправить
      data: data,
      data2: data,
      data3: data,
    },
    //делаем что-то при ответе от сервера
    function(response) {
      // console.log(response);


    }
  );
})

$('.unsubscribeUserCallback').click(function (e) {
  e.preventDefault();

  // показываем форму, перелаем в неё заголовок и сообщение
  openFormStatus('Очень жаль', 'Но если вдруг Вы передумаете — позвоните нам.');

  $.post(
    "/", //куда отправить
    {
      //что отправить
      data: data,
      data2: data,
      data3: data,
    },
    //делаем что-то при ответе от сервера
    function(response) {
      // console.log(response);


    }
  );
})



// WEBPACK FOOTER //
// ./app/blocks/form-status/form-status.js